import BuildsTvMode from './BuildsTvMode'

const DEFAULT_UPDATE_PERIOD = 60
const MILLISECONDS_IN_SECONDS_COUNT = 1000
export const buildsTvModeDefaultUrlParams: URLSearchParams = new URLSearchParams()
buildsTvModeDefaultUrlParams.set('title', 'TeamCity Builds')
buildsTvModeDefaultUrlParams.set('showDropDowns', 'true')
buildsTvModeDefaultUrlParams.set('showLogo', 'true')
buildsTvModeDefaultUrlParams.set('updatePeriod', DEFAULT_UPDATE_PERIOD.toString())

export default function BuildsTvModeContainer() {
  const searchParams = new URLSearchParams(window.location.search)
  const updatePeriodParam = searchParams.get('updatePeriod')
  return (
    <BuildsTvMode
      locator={searchParams.get('locator')}
      title={searchParams.get('title')}
      showDropDowns={searchParams.get('showDropDowns') !== 'false'}
      showLogo={searchParams.get('showLogo') !== 'false'}
      showExactStartDate={searchParams.get('showExactStartDate') !== 'false'}
      updatePeriod={
        ((updatePeriodParam != null && parseInt(updatePeriodParam, 10)) || DEFAULT_UPDATE_PERIOD) *
        MILLISECONDS_IN_SECONDS_COUNT
      }
    />
  )
}
